/** 收益页 **/
<template>
  <div class="home">
    <Layout
      type="REVENUE"
      isRevenue="true"
      :pageTitle="$t('menu.revenueDetails')"
    >
      <BasiceLayout
        :title=" $t('menu.calRevenueDetails') "
        class="revenue-layout"
      >
        <div class="revenue-detail-select">
          <div v-if="compute_bxc" style="display: flex; align-items: center; margin: 0 10px 20px 20px;">
            <!-- {{compute_bxc.toFixed(6)}} -->
            <div class="detail-total-revenue" style="margin-right: 20px;">当日设备计算总收益（{{isAllBP ? 'BP' : '元'}}）： &nbsp; &nbsp; {{totalRevenueVal || 0}}</div>
            <img
                class="revenue-icon home-icon cursor"
                src="../../../assets/revenue/exchange.png"
                @click="switchUnit('total')"
                style="padding-top: 0px;"
            >
          </div>
          <!-- <div v-if="compute_bxc" class="detail-total-revenue margin-20">当日设备计算总收益（元）: &nbsp; &nbsp; {{compute_bxc.toFixed(6)}}</div> -->
          <span class="revenue-date-wrap">{{$t('revenueDate')}}:</span>
          <el-select
            v-model="selectDate"
            filterable
            @change="search"
          >
            <el-option
              v-for="item in queryDate"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
          <span class="search-text">{{$t('search_mac_address')}}</span>
          <!-- <el-select
            v-model="searchMacAddress"
            filterable
            placeholder=""
            @change="searchMac"
          >
            <el-option
              v-for="item in allDevices"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select> -->
          <el-input class="search-mac-input" v-model="searchMacAddress" placeholder="" @change="searchMac"></el-input>
        </div>
        <el-table
          v-if="detailList !== 'NO_CONTENT'"
          :data="detailList"
          align="left"
          empty-text="-"
          style="width: 100%"
        >
          <!-- mac address -->
          <el-table-column
            prop="mac_address"
            align='center'
            :label="$t('mac_address')"
          >
          </el-table-column>
          <!-- 备注 -->
          <el-table-column
            :label="$t('noteText')"
            align='center'
          >
            <template slot-scope="scope">
              <div v-if="scope.row.note">{{scope.row.note}}</div>
              <div
                v-if="!scope.row.note"
                :deviceId="scope.row.deviceId"
                @click="showNotes(scope.row.id, scope.row.mac_address)"
                class="add-note-button button bonus-cursor"
              >
                {{$t('addNote')}}</div>
              <i
                v-if="scope.row.note && scope.row.noteStatus"
                class="el-icon-edit"
                @click="showNotes(scope.row.id, scope.row.mac_address)"
              ></i>
            </template>
          </el-table-column>
          <!-- 带宽贡献 -->
          <!-- <el-table-column prop="" :label="$t('bandwidth')" align='center'>
            <template slot-scope="scope">
              <div v-if="!scope.row.tx_bw">-</div>
              <el-tag v-if="scope.row.tx_bw < 5 && scope.row.tx_bw > 0" type="danger">&lt; 5 M</el-tag>
              <el-tag v-if="scope.row.tx_bw >= 30" type="success">&gt; 30 M</el-tag>
              <el-tag v-if="scope.row.tx_bw < 10 && scope.row.tx_bw >= 5">5-10 M</el-tag>
              <el-tag v-if="scope.row.tx_bw < 20 && scope.row.tx_bw >= 10">10-20 M</el-tag>
              <el-tag v-if="scope.row.tx_bw < 30 && scope.row.tx_bw >= 20">20-30 M</el-tag>
            </template>
          </el-table-column> -->
          <!-- 实际使用宽带 -->
          <el-table-column
            prop=""
            :label="$t('nf_out_bps')"
            align='center'
          >
            <template slot-scope="scope">
              <div v-if="scope.row.nf_out_bps">{{scope.row.nf_out_bps}} M</div>
              <div v-if="!scope.row.nf_out_bps">-</div>
            </template>
          </el-table-column>
          <!-- 设备存储 -->
          <el-table-column
            prop="ext_storage_size"
            align='center'
            :label="$t('storage')"
          ></el-table-column>
          <!-- 设备在线时长 -->
          <el-table-column
            prop="storage_time"
            align='center'
            :label="$t('storage_online')"
          ></el-table-column>
          <!-- 实际使用流量 -->
          <el-table-column
            prop=""
            :label="$t('out_bytes')"
            align='center'
            :render-header="renderHeader"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.out_bytes">{{scope.row.out_bytes}} GB</div>
              <div v-if="!scope.row.out_bytes">-</div>
            </template>
          </el-table-column>
          <!-- 运营商 -->
          <el-table-column prop="" :label="$t('operators')" align='center' :render-header="renderHeader">
             <template slot-scope="scope">
              <div v-if="scope.row.operator ==='ct'">{{$t('ct')}}</div>
              <div v-else-if="scope.row.operator ==='cu'">{{$t('cu')}}</div>
              <div v-else-if="scope.row.operator ==='cm'">{{$t('cm')}}</div>
              <div  v-else-if="scope.row.operator ==='abnormal'">异常
                <el-popover placement="bottom" width="200" trigger="hover" content="运营商采集程序异常，请重启设备并提高设备硬件配置/限制连接数等" effect="dark">
                  <i class="el-icon-warning bonus-tips" slot="reference"></i>
                </el-popover>
              </div>
              <div v-else>{{$t('unknown')}}
                <el-popover placement="bottom" width="200" trigger="hover" content="请前往微信“博纳云”工单小程序提交工单反馈" effect="dark">
                  <i class="el-icon-warning bonus-tips" slot="reference"></i>
                </el-popover>
              </div>
            </template>
          </el-table-column>
          <!-- 监测 --> 
          <el-table-column
            prop=""
            :label="$t('watch')"
            align='center'
          >
            <template slot-scope="scope">
              <img
                class="watch-icon"
                @click="showWatchDetail('id', scope.row.id, scope.row.info)"
                src="../../../assets/hardList/watch.png"
              >
            </template>
          </el-table-column>
          <!-- 设备收益（BP） -->
          <el-table-column
            prop=""
            :label="$t('device_revenue')"
            align='center'
          >
            <template slot-scope="scope">
              <span v-if="scope.row.revenue">{{scope.row.revenue}}</span>
              <span v-if="!scope.row.revenue">-</span>
              <el-tooltip v-if="scope.row.description !== 'normal'" content="晚高峰故障，权重扣减" placement="bottom" effect="dark">
                <i class="el-icon-warning fa fa-question-circle bonus-tips"></i>
              </el-tooltip>
            </template>
          </el-table-column>
          <!-- 设备收益（元） -->
          <el-table-column
            prop=""
            label="设备收益（元）"
            align='center'
          >
            <template slot-scope="scope">
              <span v-if="scope.row.revenueToRmb">{{scope.row.revenueToRmb}}</span>
              <span v-if="!scope.row.revenueToRmb">-</span>
              <el-tooltip v-if="scope.row.description !== 'normal'" content="晚高峰故障，权重扣减" placement="bottom" effect="dark">
                <i class="el-icon-warning fa fa-question-circle bonus-tips"></i>
              </el-tooltip>
            </template>
          </el-table-column>
          <!-- 历史收益 -->
          <el-table-column
            align='center'
            label="历史收益"
          >
            <template slot-scope="scope">
              <img
                class="watch-icon"
                @click="showDeviceRevenue(scope.row.id)"
                src="../../../assets/revenueBlack.png"
              >
            </template>
          </el-table-column>
        </el-table>
        <el-table
          v-if="detailList === 'NO_CONTENT'"
          :data="detailList"
          align="left"
          empty-text="system upgrade.."
          style="width: 100%"
        >
        </el-table>
        <div
          class="pagination"
          v-if="deviceNumSize > 1"
        >
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="deviceNumSize"
            layout="total, prev, pager, next"
            :total="deviceLength"
          >
          </el-pagination>
        </div>
        <!-- 增加备注 -->
        <el-dialog
          :title="$t('addNotes.title')"
          :visible.sync="showAddnoteDialog"
          width="480px"
          center
        >
          <div class="addnote-dialog-wrap">
            <span class="key">{{$t('addNotes.tipText')}}({{addNoteAddress}})</span>
            <input
              type="text"
              class="basic-input input addnote-input"
              v-model="addNoteInput"
            >
          </div>
          <span
            slot="footer"
            class="dialog-footer"
          >
            <div
              class="sure-unbind button"
              @click="showAddnoteDialog = false"
            >{{ $t('cancel') }}</div>
            <div
              class="sure-unbind button"
              type="primary"
              @click="addNote"
            >{{ $t('confirm') }}</div>
          </span>
        </el-dialog>
        <!-- 监控 -->
        <el-dialog
          :title="$t('watchDetail.title')"
          :visible.sync="showWatchDialog"
          width="60%"
          center
        >
          <div class="watch-dialog-wrap">
            <span class="key"></span>
            <div class="watch-select">
              <span class="search-text">{{$t('watchDetail.watchDate')}}:</span>
              <el-select
                v-model="searchWatchDate"
                filterable
                placeholder=""
                @change="showWatchDetail"
              >
                <el-option
                  v-for="item in watchQueryDate"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
            <div v-if="showUseBandCharts">
              <!-- <ve-line
                v-if="showCharts"
                class="watch-chart"
                :data="stableCharts"
              ></ve-line>
              <ve-line
                v-if="showCharts"
                class="watch-chart"
                :data="availabilityChart"
              ></ve-line> -->
              <!-- <ve-line
                class="watch-chart"
                :data="hardOnlineChart"
              ></ve-line>
              <ve-line
                class="watch-chart"
                :data="txBwCharts"
              ></ve-line> -->
              <ve-line
                v-if="showUseBandCharts"
                class="watch-chart"
                :data="useBandCharts"
              ></ve-line>
            </div>
          </div>
          <div
            v-if="!showUseBandCharts"
            class="no-watch-data"
          >{{$t('watchDetail.noData')}}</div>
        </el-dialog>
      </BasiceLayout>
    </Layout>
    <!-- 历史收益 -->
    <el-dialog
      title="历史收益"
      :visible.sync="showLastRevenueDialog"
      width="70%"
      center
    >
      <div class="addnote-dialog-wrap">
        <LineCharts :chartData="chartData"></LineCharts>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <div
          class="sure-unbind button"
          type="primary"
          @click="showLastRevenueDialog = false"
        >{{ $t('confirm') }}</div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Layout from "@/components/DatePanel/Layout.vue";
import RevenueContent from "@/components/RevenueDetail/RevenueContent.vue";
import BasiceLayout from "@/components/Common/BasicLayout.vue";
import moment from "moment";
import { mapActions, mapState } from "vuex";
import { Message } from "element-ui";
import { BytesToM, toFixed } from "@/utils/utils";
import LineCharts from "@/components/Common/LineCharts.vue";
const type = "calculate";

export default {
  name: "home",
  data() {
    return {
      selectDate: moment()
        .utc()
        .startOf("day")
        .subtract(1, "days")
        .format("YYYY-MM-DD"),
      searchWatchDate: moment()
        .utc()
        .startOf("day")
        .subtract(1, "days")
        .format("YYYY-MM-DD"),
      pageNum: 1,
      addNoteInput: "",
      addNoteAddress: "", //添加备注Id
      showAddnoteDialog: false,
      searchMacAddress: "",
      showWatchDialog: false, //监控弹框
      // stableCharts: {},
      availabilityChart: {},
      hardOnlineChart: {},
      txBwCharts: {},
      useBandCharts: {},
      showUseBandCharts: "waiting",
      useBandInfo: '',
      useBandDeviceId: '',
      showLastRevenueDialog: false,
      chartData: {},
      isAllBP: true,
      totalRevenueVal: '',
    };
  },
  components: {
    Header,
    Layout,
    BasiceLayout,
    LineCharts
  },
  computed: mapState({
    //  箭头函数可使代码更简练
    deviceLength: state => state.revenueDetail.deviceLength,
    currentPage: state => state.revenueDetail.currentPage,
    deviceNumSize: state => state.revenueDetail.deviceNumSize,
    detailList: state => state.revenueDetail.detailList,
    allDevices: state => state.revenueDetail.allDevices,
    compute_bxc: state => state.revenueDetail.compute_bxc, 
    queryDate: () => {
      let queryDate = [];
      let endDay = moment()
        .utc()
        .startOf("day");

      endDay -= 24 * 60 * 60 * 1000;
      let i = 0;
      while (i < 7) {
        i++;
        queryDate.push(moment(endDay).format("YYYY-MM-DD"));
        endDay -= 24 * 60 * 60 * 1000;
      }

      return queryDate;
    },
    // 监控查询过去30天时间
    watchQueryDate: () => {
      let watchQueryDate = [];
      let endDay = moment()
        .utc()
        .startOf("day");

      // endDay -= 24 * 60 * 60 * 1000;
      let i = 0;
      while (i < 30) {
        i++;
        watchQueryDate.push(moment(endDay).format("YYYY-MM-DD"));
        endDay -= 24 * 60 * 60 * 1000;
      }

      return watchQueryDate;
    }
  }),
  created() {
    let queryDate = moment()
      .utc()
      .startOf("day")
      .subtract(1, "days")
      .format("YYYY-MM-DD");
    this.queryDate = queryDate;
    let pageNum = this.pageNum;

    this.getRevenueDetail({ queryDate, pageNum, type, deviceType: "lite" }).then(res=>{
      if(res.code == 200) {
        this.totalRevenueVal = (res.ret.totalBxc.compute_bxc).toFixed(2);
      } else {
        this.totalRevenueVal = '';
      }
    })
  },
  methods: {
    ...mapActions([
      "getRevenueDetail",
      "addDeviceNotes",
      "getDeviceWatchDetail",
      "getDevicePcdnFlow",
      "getLastSevenRevenue"
    ]),
    switchUnit() {
      this.isAllBP = !this.isAllBP;
      this.totalRevenueVal = this.isAllBP ? this.RMBToBP(this.totalRevenueVal) : this.BPToRMB(this.totalRevenueVal);
    },
    BPToRMB(val) {
        return (val * 0.0029).toFixed(2);
    },
    RMBToBP(val) {
        return (val / 0.0029).toFixed(2);
    },
    // 日期搜索
    search(queryDate) {
      this.queryDate = queryDate;
      let pageNum = this.pageNum;
      this.getRevenueDetail({ queryDate, pageNum, type, deviceType: "lite" });
    },
    // mac搜索
    searchMac(mac_address) {
      let { selectDate, pageNum = 1 } = this;
      this.getRevenueDetail({
        pageNum,
        mac_address,
        queryDate: selectDate,
        type,
        deviceType: "lite"
      });
    },
    handleCurrentChange(value) {
      let defaultDate = moment()
        .utc()
        .startOf("day")
        .format("YYYY-MM-DD");
      let queryDate = this.selectDate || defaultDate;
      this.pageNum = value;
      this.getRevenueDetail({
        queryDate,
        pageNum: value,
        type,
        deviceType: "lite"
      });
    },
    // 添加备注
    addNote() {
      let that = this;
      this.addDeviceNotes({
        deviceId: this.addNoteId,
        note: this.addNoteInput
      }).then(res => {
        if (res.code === 200) {
          Message({
            type: "success",
            message: res.message
          });
          that.showAddnoteDialog = false;
          if (that.searchMacAddress === "all" || that.searchMacAddress === "") {
            this.getRevenueDetail({
              type,
              queryDate: that.selectDate,
              pageNum: that.pageNum,
              deviceType: "lite"
            });
          } else {
            this.getDeviceDetail({ id: that.searchMacAddress });
          }
        } else {
          Message({
            type: "error",
            message: res.message || "add note error"
          });
        }
      });
    },
    // 备注框
    showNotes(id, address) {
      this.showAddnoteDialog = true;
      this.addNoteId = id;
      this.addNoteAddress = address;
    },
    // 显示观察
    showWatchDetail(type, id, info) {
      let that = this;
      this.showWatchDialog = true;
      let queryDate = this.searchWatchDate;
      this.watchId = type === "id" ? id : this.watchId;
      let date_after = moment(queryDate).utc().valueOf();
      let date_before = date_after + 86400000;

      // 处理参数
      if (id) {
        that.useBandInfo = info;
        that.useBandDeviceId = id;
      } else {
        info = this.useBandInfo;
        id = this.useBandDeviceId;
      }

      // 表提示内容
      let watchStable = this.$t("watchDetail.watchStable");
      let watchAvaliable = this.$t("watchDetail.watchAvaliable");
      let watchStorge = this.$t("watchDetail.watchStorge");
      let watchDate = this.$t("watchDetail.watchDate");
      let watchUseBand = this.$t("usedBand");

      // 查询设备实际带宽
      this.getDevicePcdnFlow({
        info,
        device_id: id,
        flow_user: "total",
        date_before,
        date_after
      }).then(res => {

        if (res && res.device_pcdnflow_logging && res.device_pcdnflow_logging.length) {
           // 判断是否dcache设备
          let isDcache = false;
          res.flow_users.map(item => {
            if (item.user_name === 'dcache') {
              isDcache = true;
            }
          })

          // 此处为了中英文对照，所以动态处理
          let useBandCharts = {
            columns: [],
            rows: []
          };

          useBandCharts.columns = [
            watchDate,
            watchUseBand,
          ];

          res.device_pcdnflow_logging.map(item => {
            let { time, diffBps, out_bps } = item;
            let value = isDcache ? diffBps : out_bps;
            let date_at = moment(new Date(time)).format("YYYY-MM-DD HH:mm:ss");


            let useBandRows = [];
            // 日期处理
            useBandRows[watchDate] = date_at;
            useBandRows[watchUseBand] = toFixed(
              BytesToM(value)
            );

            useBandCharts.rows.push(useBandRows);
          });

          that.useBandCharts = useBandCharts;
          that.showUseBandCharts = true;
        } else {
          that.showUseBandCharts = false;
        }
      });
    },
    renderHeader: function(creatElement, { column, $index }) {
      let fields = this.fields;
      let that = this;
      return creatElement("div", [
        column.label,
        creatElement(
          "el-tooltip",
          {
            class: "cell-s-tip",
            props: {
              content: (function() {
                let label = column.label;
                switch (label) {
                  case "使用流量":
                    return that.$t("useBandTips");
                    break;
                  case "Data Flow":
                    return that.$t("useBandTips");
                    break;
                  case "运营商":
                    return that.$t("operator");
                    break;
                  case "Operators":
                    return that.$t("useBandTips");
                    break;
                }
              })(),
              effect: "dark",
              placement: "top"
            }
          },
          [
            creatElement("i", {
              class: "fa fa-question-circle revenue-icon el-icon-question"
            })
          ]
        )
      ]);
    },
    showDeviceRevenue(deviceId) {
      this.getLastSevenRevenue({deviceId}).then(res => {
        this.showLastRevenueDialog = true;
        // this.selectedDeviceId = deviceId;
        if (res && res.data) {
          let data = res.data;
          let chartData = {
            columns: ['日期', '当日计算总收益（BP）'],
            rows: []
          };
          for (let i in data) {
            let item = data[i];
            chartData.rows.push({
              '日期': moment(Number(i)).format('YYYY MM DD'),
              '当日计算总收益（BP）': item.compute_bxc,
            })
          }

          this.chartData = chartData;

        }
      });
    }
  }
};
</script>

<style lang="stylus">
.data-panel-wrap, .data-panel-layout, .home {
  height: 100%;
}

.revenue-all-layout {
  height: 100%;
}

.revenue-date-wrap {
  margin: 0 20px;
}

.is-mobile .revenue-detail-select {
}

.revenue-detail-select {
  text-align: left;
  padding-bottom: 30px;
  margin-bottom: 30px;
  border-bottom: 1px solid #ddd;
}

.revenue-tips {
  display: inline-block;
  margin: 0 20px;
  color: #96999b;
}

.add-note-button {
  max-width: 80px;
}
</style>

<i18n>
  {
  "zn": {
    "revenueDate": "查询日期（UTC）",
    "revenueMac": "查询MAC地址",
    "mac_address": "设备",
    "device_revenue": "设备收益（BP）",
    "noteText": "备注",
    "search_mac_address": "搜索Mac地址",
    "noteText": "备注",
    "allSearch": "全部",
    "tolal_revenue": "当日设备计算总收益（BP）",
    "bandwidth": "带宽贡献",
    "storage": "存储",
    "storage_online": "存储在线时长",
    "nf_out_bps": "实际使用带宽",
    "out_bytes": "使用流量",
    "nat": "NAT 类型",
    "useBandTips": "使用流量为当日节点上传流量，使用流量情况决定收益多少，当日使用流量的多少受同步数据流量影响。",
    "syncDataTips": "同步数据为当日节点下载流量，同步数据情况决定使用流量多少，从而决定收益情况。若当日同步数据不超过5G，请检查硬盘写入性能；同步数据较多但使用流量少，请检查设备UPNP是否正常开启，或配置DMZ。",
    "operator": "当天线路发生过移动/非移动运营商切换的，认定为移动"
  },
  "en": {
    "layoutTitle": "Device Revenue Detatils",
    "revenueDate": "Date（UTC）",
    "revenueMac": "Mac Address",
    "mac_address": "Mac Address",
    "device_revenue": "Device revenue",
    "search_mac_address": "Mac Address",
    "noteText": "Note",
    "allSearch": "All",
    "tolal_revenue": "Total Revenue",
    "bandwidth": "Bandwidth",
    "storage": "Storage",
    "storage_online": "Storage Online",
    "nf_out_bps": "Actual Bandwidth",
    "out_bytes": "Data Flow",
    "nat": "NAT Type",
    "useBandTips": "The used traffic refers to the node's upload traffic of the day, resulting in the corresponding revenue, and the used traffic amount of the day is influenced by the synchronized data traffic.",
    "syncDataTips": "The synchronized data refers to the node's download traffic of the day, and the synchronized data situation is determined by the used traffic, resulting in the corresponding revenue of the day. If the synchronized data occurs less than 5G for one day, please check the writing performance of the hard disk; if the synchronized data amount is much more than the used traffic, please check if UPNP is on normally or configure DMZ.",
    "operator": "If a mobile/non-mobile operator switch occurs on the line on the same day, it shall be identified as mobile"
  }
}
</i18n>
